<template>
  <div class="fire-detection-record">
    <MCard :title="$t('监测记录')" title-align="center">
      <search
        ref="search"
        class="custom-form-container"
        :formModel="formModel"
        :formButton="formButton"
        :deviceModelBusiType="10"
        :rules="rules"
        :mulTime="mulTime"
        :new-line="false"
        :filterDeviceFlag="true"
      ></search>

      <m-table
        max-height="550px"
        :loading="loading"
        :tableData="tableData"
        :tableColumn="tableColumn"
        :pagiOption="pagiOption"
        v-on:search="search"
      ></m-table>
    </MCard>
  </div>
</template>

<script>
import Search from '@/components/mTable/search';
import MTable from '@/components/mTable/m-table';
import MCard from '@/components/mCard/index.vue';
import { getOrdataChartData, getOrdataChartItems, queryOrdata } from '@/api/stat';
import { arrify, awaitTo, downFile, useComponent } from '@/utils/utils';
import { getTime } from '@/utils/date';
// import { getTextWidthByCanvas } from '@/utils/str';
import NDialog from '@/components/dialog/index.vue';
import MForm from '@/components/form/index.vue';
import { materialOption } from '@/echartOption/material';
import { isEmpty } from '@/utils/is';

export default {
  components: {
    Search,
    MTable,
    MCard
  },
  data() {
    const { translateTo } = this.$options.filters;

    const i18nPath = 'query';

    const timeValidate = (_, value, callback) => {
      if (!value[0] || !value[1]) {
        callback(new Error(translateTo('请选择日期', i18nPath)));
      } else if (new Date(value[1]) - new Date(value[0]) > getTime('d')) {
        callback(new Error(translateTo('时间范围不能超过一天', i18nPath)));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      i18nPath,
      formModel: {
        sn: '',
        rangeDateVal: [new Date() - 3600000, new Date().getTime()],
        // deviceModel: [],
        latestFlag: false,
        dataInterval: 1,
        dataIntervalType: 's'
      },
      formButton: [
        {
          text: '查询',
          loading: false,
          event: op => {
            this.pagiOption.offset = 1;
            this.search(op);
          }
        },
        {
          text: '导出',
          code: '010601',
          loading: false,
          event: this.hisExport
        },
        {
          text: '数据曲线',
          code: '010603',
          loading: false,
          event: this.showDataCharts
        }
      ],
      tableData: [],
      tableColumn: [],
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      rules: {
        deviceModel: [{ required: false }],
        sn: [{ required: true, message: '请选择设备', trigger: 'change' }],
        rangeDateVal: [
          { required: true, message: '请选择日期', trigger: 'change' },
          { validator: timeValidate }
        ]
      },
      mulTime: {
        mul: false,
        dateType: 'datetimerange'
      }
    };
  },
  computed: {
    comParams() {
      return {
        busiType: 1,
        dataScale: 1,
        beginTime: this.formModel.rangeDateVal[0],
        endTime: this.formModel.rangeDateVal[1],
        latestFlag: `${+this.formModel.latestFlag}`,
        sn: this.formModel.sn,
        dataInterval: this.formModel.dataInterval,
        dataIntervalType: this.formModel.dataIntervalType
      };
    }
  },
  methods: {
    langChangeHandler() {
      this.$refs.search.validateEvent({
        event: () => {
          this.search();
        }
      });
    },
    search(op) {
      this.loading = true;
      op && (op.loading = true);
      queryOrdata(
        Object.assign(
          {
            limit: this.pagiOption.limit,
            offset: this.pagiOption.offset
          },
          this.comParams
        )
      )
        .then(res => {
          this.tableData = res.data.pageData.list;
          this.tableColumn = (res.data?.dimensions || []).map((e, i) => ({
            prop: e,
            label: res.data.dimensionsZh[i]
            // width: '200px'
            // width: Math.max(getTextWidthByCanvas(res.data.dimensionsZh[i], '16px') * 2, 120) + 'px'
          }));

          this.pagiOption.total = res.data.pageData.total;
        })
        .finally(() => {
          this.loading = false;
          op && (op.loading = false);
        });
    },
    hisExport(op) {
      op.loading = true;
      downFile({
        url: '/stat/exportOrdata',
        method: 'get',
        params: Object.assign(this.comParams, { exportType: 1 })
      }).finally(() => {
        op.loading = false;
      });
    },
    showDataCharts() {
      const { formModel, comParams } = this;

      const component = useComponent({
        components: { NDialog, MForm },
        template: `
          <NDialog ref="dialogRef" width="70vw" margin-top="5%" :title="$t('数据曲线')">
            <div class="scrollbar-thin" style="overflow-y: auto; overflow-x: hidden; height:43vw; max-height:60vh;">
              <MForm v-bind="dialogFormConfig"></MForm>

              <div style="height:40vw; max-height:55vh;" v-for="(options, i) in chartOptions">
                <v-chart :options="options" :autoresize="true"></v-chart>
              </div>
            </div>
          </NDialog>
        `,
        data() {
          return {
            loading: false,
            chartOptions: [],
            dialogFormConfig: {
              inline: true,
              i18nPath: 'query',
              config: {
                labelWidth: '',
                span: 8,
                options: [
                  {
                    type: 'select',
                    prop: 'cols',
                    multiple: true,
                    collapseTags: true,
                    labelNeedTranslation: true,
                    clearable: true,
                    dataKey: 'colList',
                    placeholder: '请选择',
                    label: '数据指标'
                  }
                ],
                operation: {
                  span: 6,
                  buttons: [
                    {
                      text: '查询',
                      loading: false,
                      type: 'primary',
                      handler: async ({ setLoading }) => {
                        setLoading(true);
                        await this.search();
                        setLoading(false);
                      }
                    },
                    {
                      text: '重置',
                      loading: false,
                      type: 'primary',
                      handler: async ({ setLoading }) => {
                        setLoading(true);
                        this.resetSearch();
                        setLoading(false);
                      }
                    }
                  ]
                }
              },
              model: {
                cols: []
              },
              dataSource: {
                colList: []
              },
              rules: {
                fields: [{ message: '请选择', trigger: 'blur' }]
              }
            },
            colDict: {}
          };
        },
        methods: {
          async initChartDimansions() {
            const [err, res] = await awaitTo(getOrdataChartItems({ sn: arrify(formModel.sn) }));

            if (err) {
              return;
            }

            const cols = res.data.map(e => {
              this.colDict[e.itemCode] = e.itemName;
              this.colDict[e.itemName] = e.itemCode;

              return { label: e.itemName, value: e.itemCode };
            });
            this.dialogFormConfig.dataSource.colList.push(...cols);
          },
          async search() {
            const [err, res] = await awaitTo(
              getOrdataChartData({
                ...comParams,
                ...this.dialogFormConfig.model,
                sn: arrify(formModel.sn),
                // beginTime: 1721115934707,
                // endTime: 1721117056216,
                // sn: ['1080100009'],
                busiType: arrify(comParams.busiType)
              })
            );

            if (err) return console.log(err);

            const data = res.data;

            if (isEmpty(data)) return;

            const { time, ...map } = data;

            this.chartOptions.splice(0, Infinity);

            Object.keys(map).forEach(key => {
              const opts = materialOption({
                title: { text: this.colDict[key] },
                xAxis: { data: time },
                series: [{ data: map[key] }]
              });

              this.chartOptions.push(opts);
            });
          },
          resetSearch() {},
          cancel() {
            this.$refs.dialogRef.beforeClose();
          }
        },
        mounted() {
          this.initChartDimansions();
        }
      });

      component.$mount();
    }
  }
};
</script>

<style lang="scss">
.fire-detection-record {
  width: calc(100% - 155px);
  height: calc(100% - 30px);
  margin-left: var(--gap);

  box-sizing: border-box;

  .m-card_content {
    padding: 20px;
    box-sizing: border-box;

    overflow: auto;

    @include scrollar-style-thin;
  }
}
</style>
